<script>
import TwCard from '@/components/generic/tw-card.vue'

export default {
  name: 'OrganizationImportPage',
  components: { TwCard }
}
</script>

<template>
  <div>
    <h2>Organization Import Page</h2>
    <tw-card> Import your data from GroupRev </tw-card>
  </div>
</template>

<style scoped>

</style>
